var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 176,
    viewBox: "0 0 152 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Animation placeholder"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 62.5,
    y: 2,
    width: 87,
    height: 112,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_2",
    x: 50.5,
    y: 14,
    width: 87,
    height: 112,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_3",
    x: 38.5,
    y: 26,
    width: 87,
    height: 112,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_4",
    x: 26.5,
    y: 38,
    width: 87,
    height: 112,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_5",
    x: 14.5,
    y: 50,
    width: 87,
    height: 112,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_6",
    x: 2.5,
    y: 62,
    width: 87,
    height: 112,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Shape_7",
    cx: 28.5,
    cy: 96,
    r: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    d: "M63.5 114C63.5 119.039 61.4982 123.872 57.935 127.435C54.3718 130.998 49.5391 133 44.5 133C39.4609 133 34.6282 130.998 31.065 127.435C27.5018 123.872 25.5 119.039 25.5 114L44.5 114H63.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape_9",
    cx: 53.5,
    cy: 96,
    r: 6,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmile);
export default __webpack_public_path__ + "static/media/logo-smile.36c41c48969d5d0ef0aede93e0643204.svg";
export { ForwardRef as ReactComponent };